import { ConsentActionOutcomeV1, ConsentActionV1 } from '@csp/dmdp-api-consent-dto';
import { ConsentArtifactConfigV2 } from './ConsentArtifact';
import { ConsentRequestConfigMeta } from './ConsentRequestConfigMeta';

export type ConsentActionWithArtifactMeta = ConsentActionV1 & { artifactMeta: { CONFIG_V2: ConsentArtifactConfigV2 } };

export type ConsentActionOutcomeV1WithArtifactAndScheduleMeta = ConsentActionOutcomeV1 & {
  artifactMeta: { CONFIG_V2: ConsentArtifactConfigV2 };
  scheduleMeta: ConsentRequestConfigMeta;
};

export enum ConsentActionStatusValue {
  WITHDRAWN = 'WITHDRAWN',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}
